<template>
  <div>
    <div>
      <div
        class="modal fade show"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        v-if="workflowStore.authModal"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">계정 등록</h5>
            </div>
            <div class="modal-body">
              <div >
                <div v-for="(form, index) in $store.state.workflowStore.modalInput" :key="index">
                  <div >
                    <h6 class="card-inside-title">{{ form.key }}</h6>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.value"
                        :placeholder="form.label"
                      />
                    </div>


                  </div>
                </div>
              </div>
              <div id="test1111">
                <button
                  id="authModalLoginBtn"
                  type="button"
                  class="btn btn-default"
                  :disabled="saveBtn"
                  @click="authLogin()"
                >
                  로그인
                </button>
              </div>
              <!-- <h6 class="card-inside-title">라벨</h6>
              <select class="form-control show-tick">
                <option value="">test1</option>
                <option value="">test2</option>
                <option value="">test3</option>
              </select> -->
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-default"
                @click="closeModal"
              >
                닫기
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventbus from "@/store/modules/devEventBus";

export default {
  name: "auth",
  data() {
    return {
      userAuthModal : false,
      saveBtn : false,
      forms : [],
      checkNum : null,

      componentType : null,
    };
  },
  computed: {
    workflowStore() {
      return this.$store.state.workflowStore;
    },
    userStore() {
      return this.$store.state.userStore;
    },
    modalData() {
      return this.$store.state.workflowStore.modalData;
    },
    trueFalseModal(){
      console.log("ddddddddddddddddddddddddddddddddddddddddddd")
      return this.$store.getters.getUserAuthModal
    },
    getAuthModal(){
      console.log("dfsfds")

      return this.$store.getters.getAuthModal}
  },
  watch:{
    getAuthModal(status){
      console.log("ddd",status);

      this.setFormsDatas();

    }
  },

  methods: {
    // showModal(tag, status) {
    //   var param = {};
    //
    //   this.$store.dispatch("showModal", {
    //     params: param,
    //     tag: tag,
    //     status: status,
    //   });
    //
    //   document.getElementsByClassName("overlay")[0].style.display = "none";
    // },
    authLogin() {

      // eventbus.$off("openAuthModal")

      this.forms = this.$store.state.workflowStore.modalInput

      this.saveBtn = true;

      var schema = this.$store.state.devStore.apiData.apiSchema;

      var keyText = "x-";


      var json = JSON.parse(schema)

      var headers = json.configure.header;
      var bodys = json.configure.requestBody;
      var params = json.configure.urlParam;
      // var form = json.design.forms;

      for(var m = 0; m < this.forms.length; m++){
        console.log(m)
        console.log(this.forms.length)
        console.log(this.forms[m])

        var char = Array.from(this.forms[m].key);
        for(var j = 0; j < char.length; j++){
          if(/[A-Z]/.test(char[j])){
            console.log("대문자", char[j])
            keyText = keyText + "-" + char[j]

          } else {
            console.log("아님", char[j])
            keyText += char[j]

          }
        }

        keyText = keyText.toUpperCase();

        console.log(keyText)

        for(var n1 = 0; n1 < Object.keys(headers).length; n1++){
          if(Object.keys(headers)[n1] == keyText){
            headers[keyText] = this.forms[m].value
          }
        }
        if(Object.keys(bodys).length > 0){
          for(var n2 = 0; n2 < Object.keys(bodys).length; n2++){
            if(Object.keys(bodys)[n2] == this.forms[m].key){
              bodys[this.forms[m].key] = this.forms[m].value
            }
          }
        }
        if(Object.keys(params).length > 0){
          for(var n3 = 0; n3 < Object.keys(params).length; n3++){
            if(Object.keys(params)[n3] == this.forms[m].key){
              params[this.forms[m].key] = this.forms[m].value
            }
          }
        }


      }

      console.log(headers)
      console.log(bodys)
      console.log(params)
      console.log(json)

      this.checkNum = this.$store.state.workflowStore.modalData


      //요청 보내기
      this.api.checkApi({schema : JSON.stringify(json)})
      .then((res)=>{
        console.log(res)

        if(res.code == 0){

          var array = new Array()
          array.push(this.forms)


          //계정 등록 하기  auth에 하고 리스트 다시 불러오기
          var param = {
            apiCode : this.$store.state.workflowStore.workflowsS[this.checkNum].api.apiCode,
            workflowCode : this.$store.state.workflowStore.workflowCode,
            connectionName : this.$store.state.workflowStore.workflowsS[this.checkNum].api.appName,
            paramData : JSON.stringify(this.forms)
          }

          console.log("parama ::: ", param)
          this.api.addConnection(param)
          .then((res)=>{
            console.log(res)

            this.saveBtn = false;
            this.closeModal()

          })

        } else {
          console.log("오류 발생")

        }


      })
    },
    setFormsDatas() {
      console.log("set forms data ")



      this.checkNum = this.$store.state.workflowStore.modalData

      this.componentType = "resetApiDetail" + this.$store.state.workflowStore.modalData


      console.log(this.$store.state.devStore.apiAuth);



      // var apiCode = this.$store.state.devStore.apiData.apiCode;
      //
      // var param = {
      //   // appCode: this.$store.state.devStore.appCode,
      //   apiCode: apiCode,
      //   // versionCode : this.$store.state.devStore.apiData.versionCode
      //
      //   // paramData : JSON.stringify(this.forms)
      // };
      //
      // this.api.selectOneApi(param)
      // .then((res)=>{
      //
      //   console.log(res)
      //
      //   // this.forms = [];
      //
      //   var formform = [];
      //
      //   var today = new Date();
      //
      //   var year = today.getFullYear();
      //   var month = ("0" + (1 + today.getMonth())).slice(-2);
      //   var day = ("0" + today.getDate()).slice(-2);
      //
      //   var insertDt =  year + "-" + month + "-" + day;
      //
      //
      //   // if(this.$store.state.devStore.formsData != null){
      //   for (
      //       var i = 0;
      //       i < JSON.parse(res.api.apiSchema).design.forms.length;
      //       i++
      //   ) {
      //     // console.log(JSON.parse(res.api.apiSchema).design.forms[i])
      //     var list = new Object();
      //
      //     list = {
      //       key: JSON.parse(res.api.apiSchema).design.forms[i].keys.replace(
      //           /"/gi,
      //           ""
      //       ),
      //       label: "{{bundle.authData." + JSON.parse(res.api.apiSchema).design.forms[i].keys.replace(/"/gi, "") + "}}",
      //       value: "",
      //       insertDt: insertDt,
      //       index: i + 1,
      //     };
      //     formform.push(list);
      //   }
      //
      //   this.forms = formform;
      // })
      // .catch(() => alert("오류가 발생했습니다. auth 2"));
    },
    closeModal(){

      this.$store.state.workflowStore.modalInput = []



      this.$store.dispatch("setAuthModal", {
        params : 'reload',
        status : false

      });

      // eventbus.$off("openAuthModal")
      // eventbus.$off("openAuthModal")


      // this.userAuthModal = false;
      // document.getElementsByClassName("overlay")[0].style.display = "none";
      //
      // eventbus.$emit(this.componentType)
    }
  },
  mounted() {
    console.log("user auth. mounted")
  },
  created() {


    console.log("user auth. created")
    eventbus.$once("openAuthModal", (num)=>{


      // console.log("클릭2")
      //
      this.checkNum = num;
      //
      // this.componentType = "resetApiDetail" + num
      // console.log(this.componentType)

      this.forms = [];
      this.setFormsDatas()



      console.log("요청 홈 modal ")

    //   this.userAuthModal = true;
    //   document.getElementsByClassName("overlay")[0].style.display = "revert";
    //   this.setFormsDatas();
    //
    })
  },
  beforeDestroy() {

    // eventbus.$off("openAuthModal")
  }
};
</script>

